module.exports = __webpack_public_path__ + "static/media/DFL.7c88d7f4.png";